import type { DecodeRunView } from '@aztec-realms/shared-types';

/** Navigation presentation follows the selected server session, never a remembered entry route. */
export function decodeCompletionAction(
  decode: DecodeRunView,
  settlementPath: string,
  goal?: { label: string; path: string },
) {
  if (decode.rewardMode === 'civic_only')
    return {
      kind: 'civic' as const,
      label: 'Return to your expedition',
      path: '/tribe#civic-expedition-title',
    };
  if (decode.rewardMode === 'weave_only')
    return {
      kind: 'weave' as const,
      label: 'Return to Knowledge Weaves',
      path: '/explore?panel=weaves',
    };
  if (decode.rewardMode !== 'personal_materials' && decode.sourceDiscoveryId)
    return { kind: 'world' as const, label: 'Return to Explore', path: '/explore' };
  return {
    kind: 'settlement' as const,
    label: goal ? `Return to ${goal.label}` : 'Continue to settlement',
    path: goal?.path ?? settlementPath,
  };
}
